import { useMutation, UseMutationResult } from "@tanstack/react-query";

import { useInvoiceService } from "contexts/ServiceContext";
import { ApiStatusException } from "services/apiErrors";
import { AI_EVENTS, useTrackEvent } from "../../useAppInsight";

const useInvoiceFiles = (): UseMutationResult<
  DocumentsFile[] | undefined,
  ApiStatusException,
  {
    docEntry: number | undefined;
    isCredit?: boolean;
  }
> => {
  const invoiceService = useInvoiceService();
  const trackQuery = useTrackEvent(AI_EVENTS.API_REQUEST);
  const trackQueryError = useTrackEvent(AI_EVENTS.API_ERROR);

  return useMutation({
    mutationKey: ["document-files", "invoice"],
    mutationFn: ({ docEntry, isCredit }) => {
      const eventId = trackQuery({
        endpoint: `${
          isCredit ? "CreditMemo" : "Invoice"
        }/GetFileUriList/{DocEntry}`,
        parameters: {
          docEntry,
          isCreditMemo: isCredit,
        },
      });
      return docEntry
        ? invoiceService
            .getReleaseFileList(docEntry, isCredit)
            .then((data) => data.value)
            .catch((err) => {
              trackQueryError(
                {
                  statusCode: err.statusCode,
                  message: err.message,
                },
                eventId
              );
              throw err;
            })
        : Promise.reject();
    },
  });
};

export default useInvoiceFiles;
